"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const expressions_1 = __importDefault(require("./expressions"));
const types_1 = require("../tokens/types");
const getTokensForExpressionList = (expressionList) => {
    return expressionList.map((expression) => ({
        type: types_1.TokenType.TOKENS,
        value: (0, expressions_1.default)(expression),
    }));
};
exports.default = getTokensForExpressionList;
